// extracted by mini-css-extract-plugin
export var anchor = "_3w-0";
export var discard = "_3w-4";
export var muiTooltipTooltip = "_3w-6";
export var notificationBar = "_3w-3";
export var saveButtonHoverSlotWrapper = "_3w-5";
export var show = "_3w-2";
export var spacer = "_3w-1";